export default "__VITE_ASSET__BU2RK_$m__"